import { type ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import logoIcon from '@/assets/logo-icon.svg';
import { Button } from '@/components/ui';

function LogoBlock(): ReactNode {
  return (
    <div
      data-bubble-anchor
      className="animate-hero-in flex flex-col items-center gap-sm sm:gap-md"
    >
      <img
        src={logoIcon}
        alt="The 3333 Games"
        className="h-10 w-10 sm:h-14 sm:w-14"
      />
      <h1 className="font-display text-2xl font-bold tracking-tight text-text-primary sm:text-3xl">
        The 3333 Games
      </h1>
    </div>
  );
}

// La home ya no invita a apuntarse: fuera el subtitulo y el boton de
// "Unirme al juego". Solo queda la puerta de entrada, y el servidor la
// limita a admins (pocketbase/hooks/admin-only-auth.pb.js).
function EnterButton(): ReactNode {
  const nav = useNavigate();
  return (
    <div
      data-bubble-anchor
      className="animate-hero-in flex w-full max-w-[260px] flex-col"
      style={{ animationDelay: '200ms' }}
    >
      <Button size="lg" className="w-full" onClick={() => nav('/login')}>
        Ya soy jugador
      </Button>
    </div>
  );
}

export function HomeContent(): ReactNode {
  return (
    <div className="relative z-10 flex flex-col items-center gap-md px-base text-center sm:gap-lg">
      <LogoBlock />
      <EnterButton />
    </div>
  );
}
